<br class="mt-2" />
<app-title [title]="'Pedido realizado'" style="margin-top: 3rem; margin-bottom: 1rem"></app-title>

<div class="row col-xs-12 mt-4 ml-3">
  <h4 class="black">Detalle del pedido</h4>
</div>

<hr style="margin-bottom: 3rem; margin-top: 0" />

<div class="finshdOrdrContGrid">
  <div class="textAlCenter">
     <h2>
       ¡Tu cotización a sido realizado con
       <a [routerLink]="['/my-account/quote-detail', quote?.code]" class="orderSuccesT">éxito!</a>
     </h2>
  </div>
  <div class="pedidoRealizadoContainer" style="text-align: center">
    <img src="/assets/img/pedido-realizado.png" alt="" />
  </div>
  <div class="ordrContainer">
    <div class="readyOrderCot lightGrey">
      <div class="mt-3 cotNumberTitle">
        <p class="bold">Tu número de cotización es</p>
      </div>
      <div class="cotNumber">
        <h1 class="textPrimaryBlue">{{ quote?.quoteErpCode }}</h1>
      </div>
    </div>
  </div>
  <div class="ordrBtnCont">
    <div class="gridBtnsCont">
      <div class="start">
        <button class="mt-3 btn btn-secondary" [routerLink]="{ cxRoute: 'home' } | cxUrl">Continuar Comprando</button>
      </div>
      <div class="end">
        <button class="mt-3 btn btn-primary" [routerLink]="{ cxRoute: 'orders' } | cxUrl">Ir a mis pedidos</button>
      </div>
    </div>
  </div>
</div>

<br class="mt-2" />
